import { render } from "./LegoInfoBox.vue?vue&type=template&id=250b4096"
import script from "./LegoInfoBox.vue?vue&type=script&lang=js"
export * from "./LegoInfoBox.vue?vue&type=script&lang=js"

import "./LegoInfoBox.vue?vue&type=style&index=0&id=250b4096&lang=scss"
script.render = render

export default script